import { c as _c } from "react/compiler-runtime";
import { useMutation } from "@tanstack/react-query";
import { type FormEvent, useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import CfInfoDialog from "@/components/pop-ui/cf-info-dialog";
import { toast } from "@/components/pop-ui/pop-toast";
import { authClient } from "@/lib/auth/auth-client";
import { handleAuthCall } from "@/lib/auth/auth-utils";
import { getAuthHeadersWaitSign } from "@/lib/auth/td-utils";
import { useGlobalConfig } from "@/providers/global-config-context";
import { trackSignUp } from "@/track/gtm";
import { CodeInput, type CodeInputRef } from "../components/code-input";
import { Button, Input } from "../components/form-items";
import { formatPhoneParam, handleAuthApiError, type UserFormErrors } from "../utils";

// 手机注册组件
export function RegisterFormPhone(t0) {
  const $ = _c(64);
  const {
    phone,
    area,
    onFinish
  } = t0;
  const [code, setCode] = useState("");
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      code: "",
      password: ""
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const [errors, setErrors] = useState(t1);
  const [isTimedOut, setIsTimedOut] = useState(false);
  const timeoutRef = useRef(null);
  const codeInputRef = useRef(null);
  const {
    t
  } = useTranslation();
  const {
    globalConfig
  } = useGlobalConfig();
  let t2;
  if ($[1] !== area || $[2] !== phone) {
    t2 = formatPhoneParam(phone, area);
    $[1] = area;
    $[2] = phone;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const phoneParam = t2;
  const [captchaOpen, setCaptchaOpen] = useState(false);
  const [turnstileCompleted, setTurnstileCompleted] = useState(false);
  const [isTurnstileLoading, setIsTurnstileLoading] = useState(false);
  const handleTurnstileSuccess = token => {
    setCaptchaOpen(false);
    setTurnstileCompleted(true);
    sendVerificationCode(token);
  };
  let t3;
  if ($[4] !== t) {
    t3 = () => {
      setIsTurnstileLoading(false);
      setCaptchaOpen(false);
      toast.error(t("gateway.error.476"));
    };
    $[4] = t;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const handleTurnstileError = t3;
  let t4;
  if ($[6] !== phoneParam || $[7] !== t) {
    t4 = async cfTurnstileToken => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
      timeoutRef.current = setTimeout(() => {
        setIsTimedOut(true);
        toast.error(t("toast.error.requestTimeout", "Request timeout"));
      }, 30000);
      ;
      try {
        const requestHeaders = await getAuthHeadersWaitSign("phone-register", {
          "x-captcha-response": cfTurnstileToken
        });
        const result = await handleAuthCall(authClient.phoneNumber.sendOtp({
          phoneNumber: phoneParam,
          fetchOptions: {
            headers: requestHeaders
          }
        }));
        if (timeoutRef.current) {
          clearTimeout(timeoutRef.current);
          timeoutRef.current = null;
        }
        return result;
      } catch (t5) {
        const error = t5;
        if (timeoutRef.current) {
          clearTimeout(timeoutRef.current);
          timeoutRef.current = null;
        }
        throw error;
      }
    };
    $[6] = phoneParam;
    $[7] = t;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  let t6;
  if ($[9] !== t) {
    t5 = () => {
      setTimeout(() => {
        codeInputRef.current?.startCountdown();
      }, 500);
      toast.success(t("toast.success.verificationCodeSentToYourPhone"));
    };
    t6 = error_0 => {
      setCaptchaOpen(false);
      setTurnstileCompleted(false);
      handleAuthApiError(error_0, t("toast.error.sendCodeFailedTryLater"));
    };
    $[9] = t;
    $[10] = t5;
    $[11] = t6;
  } else {
    t5 = $[10];
    t6 = $[11];
  }
  let t7;
  if ($[12] !== t4 || $[13] !== t5 || $[14] !== t6) {
    t7 = {
      mutationFn: t4,
      onSuccess: t5,
      onError: t6
    };
    $[12] = t4;
    $[13] = t5;
    $[14] = t6;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  const {
    mutate: t8,
    isPending: isSendingCode
  } = useMutation(t7);
  const sendVerificationCode = t8;
  let t9;
  if ($[16] !== code || $[17] !== phoneParam || $[18] !== t) {
    t9 = async () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
      timeoutRef.current = setTimeout(() => {
        setIsTimedOut(true);
        toast.error(t("toast.error.requestTimeout", "Request timeout"));
      }, 30000);
      ;
      try {
        const requestHeaders_0 = await getAuthHeadersWaitSign("phone-register", {});
        const result_0 = await handleAuthCall(authClient.phoneNumber.verify({
          phoneNumber: phoneParam,
          code,
          fetchOptions: {
            headers: requestHeaders_0
          }
        }));
        if (timeoutRef.current) {
          clearTimeout(timeoutRef.current);
          timeoutRef.current = null;
        }
        return result_0;
      } catch (t10) {
        const error_1 = t10;
        if (timeoutRef.current) {
          clearTimeout(timeoutRef.current);
          timeoutRef.current = null;
        }
        throw error_1;
      }
    };
    $[16] = code;
    $[17] = phoneParam;
    $[18] = t;
    $[19] = t9;
  } else {
    t9 = $[19];
  }
  let t10;
  if ($[20] !== onFinish) {
    t10 = data => {
      if (data?.session?.userId) {
        trackSignUp({
          pop_user_id: data.session.userId,
          status: "success"
        });
      }
      if (onFinish) {
        onFinish();
      }
    };
    $[20] = onFinish;
    $[21] = t10;
  } else {
    t10 = $[21];
  }
  let t11;
  if ($[22] !== t) {
    t11 = error_2 => {
      setCaptchaOpen(false);
      setTurnstileCompleted(false);
      trackSignUp({
        pop_user_id: "",
        status: "failed"
      });
      handleAuthApiError(error_2, t("toast.error.registerFailedTryLater"));
    };
    $[22] = t;
    $[23] = t11;
  } else {
    t11 = $[23];
  }
  let t12;
  if ($[24] !== t10 || $[25] !== t11 || $[26] !== t9) {
    t12 = {
      mutationFn: t9,
      onSuccess: t10,
      onError: t11
    };
    $[24] = t10;
    $[25] = t11;
    $[26] = t9;
    $[27] = t12;
  } else {
    t12 = $[27];
  }
  const {
    mutate: register,
    isPending: isRegistering
  } = useMutation(t12);
  let t13;
  if ($[28] !== globalConfig?.PUBLIC_TURNSTILE_ENABLED || $[29] !== sendVerificationCode) {
    t13 = () => {
      const sendInitialCode = async () => {
        if (!globalConfig?.PUBLIC_TURNSTILE_ENABLED) {
          sendVerificationCode("");
        }
      };
      setTimeout(() => {
        sendInitialCode();
      }, 500);
    };
    $[28] = globalConfig?.PUBLIC_TURNSTILE_ENABLED;
    $[29] = sendVerificationCode;
    $[30] = t13;
  } else {
    t13 = $[30];
  }
  const t14 = globalConfig?.PUBLIC_TURNSTILE_ENABLED;
  let t15;
  if ($[31] !== t14) {
    t15 = [t14];
    $[31] = t14;
    $[32] = t15;
  } else {
    t15 = $[32];
  }
  useEffect(t13, t15);
  let t16;
  if ($[33] !== globalConfig?.PUBLIC_TURNSTILE_ENABLED || $[34] !== sendVerificationCode || $[35] !== turnstileCompleted) {
    t16 = async () => {
      setIsTimedOut(false);
      setErrors(_temp);
      if (!globalConfig?.PUBLIC_TURNSTILE_ENABLED) {
        sendVerificationCode("");
        return;
      }
      if (!turnstileCompleted) {
        setCaptchaOpen(true);
        return;
      }
      sendVerificationCode("");
    };
    $[33] = globalConfig?.PUBLIC_TURNSTILE_ENABLED;
    $[34] = sendVerificationCode;
    $[35] = turnstileCompleted;
    $[36] = t16;
  } else {
    t16 = $[36];
  }
  const handleResendCode = t16;
  let t17;
  if ($[37] !== code || $[38] !== register || $[39] !== t) {
    t17 = async e => {
      e.preventDefault();
      setIsTimedOut(false);
      if (!code) {
        setErrors(prev_0 => ({
          ...prev_0,
          code: t("toast.error.enterVerificationCode")
        }));
        return;
      } else {
        if (code.length !== 6) {
          setErrors(prev_1 => ({
            ...prev_1,
            code: t("toast.error.enter6DigitVerificationCode")
          }));
          return;
        }
      }
      register();
    };
    $[37] = code;
    $[38] = register;
    $[39] = t;
    $[40] = t17;
  } else {
    t17 = $[40];
  }
  const handleRegister = t17;
  const isLoading = (isSendingCode || isRegistering || isTurnstileLoading) && !isTimedOut;
  let t18;
  if ($[41] !== phoneParam) {
    t18 = <div className="space-y-2"><Input id="account" type="text" value={phoneParam} disabled={true} className="bg-gray-100" /></div>;
    $[41] = phoneParam;
    $[42] = t18;
  } else {
    t18 = $[42];
  }
  let t19;
  if ($[43] !== captchaOpen || $[44] !== handleTurnstileError || $[45] !== handleTurnstileSuccess) {
    t19 = <CfInfoDialog open={captchaOpen} onOpenChange={setCaptchaOpen} containerId="cf-turnstile-container-register-dialog" onTurnstileSuccess={handleTurnstileSuccess} onTurnstileError={handleTurnstileError} />;
    $[43] = captchaOpen;
    $[44] = handleTurnstileError;
    $[45] = handleTurnstileSuccess;
    $[46] = t19;
  } else {
    t19 = $[46];
  }
  let t20;
  if ($[47] !== code || $[48] !== errors.code || $[49] !== handleResendCode || $[50] !== isLoading) {
    t20 = <CodeInput ref={codeInputRef} value={code} onChange={setCode} onResend={handleResendCode} error={errors.code} disabled={isLoading} autoStartCountdown={false} />;
    $[47] = code;
    $[48] = errors.code;
    $[49] = handleResendCode;
    $[50] = isLoading;
    $[51] = t20;
  } else {
    t20 = $[51];
  }
  let t21;
  if ($[52] !== isRegistering || $[53] !== t) {
    t21 = isRegistering ? t("button.registering") : t("button.createMyAccount");
    $[52] = isRegistering;
    $[53] = t;
    $[54] = t21;
  } else {
    t21 = $[54];
  }
  let t22;
  if ($[55] !== isLoading || $[56] !== t21) {
    t22 = <Button type="submit" className="w-full" size="lg" loading={isLoading}>{t21}</Button>;
    $[55] = isLoading;
    $[56] = t21;
    $[57] = t22;
  } else {
    t22 = $[57];
  }
  let t23;
  if ($[58] !== handleRegister || $[59] !== t18 || $[60] !== t19 || $[61] !== t20 || $[62] !== t22) {
    t23 = <form onSubmit={handleRegister} className="space-y-3">{t18}{t19}{t20}{t22}</form>;
    $[58] = handleRegister;
    $[59] = t18;
    $[60] = t19;
    $[61] = t20;
    $[62] = t22;
    $[63] = t23;
  } else {
    t23 = $[63];
  }
  return t23;
}
function _temp(prev) {
  return {
    ...prev,
    code: ""
  };
}